import type { Socket } from "socket.io-client";
import type {
  ClientToServerEvents,
  ServerToClientEvents,
} from "@paladin/events";

import { io } from "socket.io-client";

import { auth0AuthProvider } from "~/pld/services/auth0";

export const socket: Socket<ServerToClientEvents, ClientToServerEvents> = io(
  import.meta.env.VITE_API_URL,
  {
    autoConnect: false,

    withCredentials: true,
  },
);

type SocketQuery = Record<string, string> & { room?: string };

export const getSocket = async (query: SocketQuery) => {
  // Get the token first, before creating the socket
  const token = await auth0AuthProvider.getTokenSilently();

  if (!token) {
    throw new Error("Failed to get authentication token for socket connection");
  }

  const socket: Socket<ServerToClientEvents, ClientToServerEvents> = io(
    import.meta.env.VITE_API_URL,
    {
      autoConnect: false,
      query,
      withCredentials: true,
      auth: {
        "x-auth-token": token,
      },
    },
  );

  return socket;
};
